import {
  type PermissionTierEnum,
  PermissionTiers,
} from '../../entities/enums/PermissionTierEnum'

export function mapTierApiModelToEnum(tier: 'Basic' | 'Pro'): PermissionTierEnum
export function mapTierApiModelToEnum(
  tier: string
): PermissionTierEnum | undefined
export function mapTierApiModelToEnum(
  tier: string
): PermissionTierEnum | undefined {
  switch (tier) {
    case 'Basic':
      return PermissionTiers.BASIC
    case 'Pro':
      return PermissionTiers.PRO
    default:
      return undefined
  }
}
